import React from 'react'
import { useTranslation } from 'react-i18next'

import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Link from '@mui/material/Link'
import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type BookingConfirmationDialogProps = {
  onClose?: () => void
  open: boolean
  orderId: string
}

export function BookingConfirmationDialog(props: BookingConfirmationDialogProps) {
  const { onClose, open, orderId } = props
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: '500px' } }}>
      <DialogContent>
        <Stack alignItems="center" spacing={2}>
          <Avatar sx={{ backgroundColor: colors.green100 }}>
            <CheckRoundedIcon htmlColor={colors.green600} />
          </Avatar>
          <Stack alignItems="center" maxWidth={400} spacing={1}>
            <Typography sx={{ fontSize: '18px', fontWeight: 500, lineHeight: '24px', color: colors.gray900 }}>
              {t('page.booking.bookingConfirmationDialog.title')}
            </Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: 400, lineHeight: '20px', color: colors.gray500, textAlign: 'center' }}>
              {t('page.booking.bookingConfirmationDialog.subtitle')}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Stack direction="row" spacing={2}>
          <Button onClick={onClose} variant="neutral">
            {t('common:button.close.label')}
          </Button>
          <LoadingButton LinkComponent={Link} href={`/order-tracking?order=${orderId}`} target="_blank" variant="contained">
            {t('page.booking.bookingConfirmationDialog.trackOrderButton.label')}
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default BookingConfirmationDialog
